module.exports = __webpack_public_path__ + "static/media/crm-not-active-image.fe3c9d6c.svg";